<script>
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import OurLocation from '$lib/PageSections/OurLocation/OurLocation.svelte';

	import mediaKitImage from './images/media-hub-001.jpg';
	import popularMechanicsLogo from './images/media-hub-color-logo-001.png';
	import thisOldHouseLogo from './images/media-hub-color-logo-002.png';
	import atomicRanchLogo from './images/media-hub-color-logo-003.png';
	import theNewYorkTimesLogo from './images/media-hub-color-logo-004.png';
	import bestGreenWorkplacesLogo from './images/media-hub-color-logo-006.png';
	import vintageRevivalLogo from './images/media-hub-color-logo-007.png';
	import theCraftmansBlogLogo from './images/media-hub-color-logo-008.png';
	import environmentalLeaderLogo from './images/media-hub-color-logo-010.png';
	import dwellLogo from './images/media-hub-color-logo-012.png';
	import dayMomLogo from './images/media-hub-color-logo-015.png';
	import yellowBrickHomeLogo from './images/media-hub-color-logo-016.png';
	import entrepreneursLogo from './images/media-hub-color-logo-017.png';
</script>

<Section backgroundColor="white">
	<p>
		Media outlets from Popular Mechanics to This Old House have featured Indow
		and our innovative inserts because there’s nothing quite like them when it
		comes to blocking drafts and reducing noise in existing windows. We’ve won
		awards, too, for making the built environment more energy efficient to fight
		climate change. Read on to learn more about our achievements and work in the
		world.
	</p>
	<Image
		src={mediaKitImage}
		alt="Media outlets that have featured Indow windows."
	/>

	<hr />
	<h2>Read</h2>
	<Grid
		columns={4}
		rows={1}
		breakOnTablet
		class="w-full list-none place-items-center justify-between"
	>
		<li>
			<a
				href="https://www.popularmechanics.com/home/interior-projects/a22285/these-ingenious-window-inserts-will-slash-your-heating-bill/"
				target="_blank"
				rel="noreferrer"
				><Image
					class="max-w-44"
					src={popularMechanicsLogo}
					alt="Popular Mechanics"
				/></a
			>
		</li>
		<li>
			<a
				href="https://www.thisoldhouse.com/windows/21019148/new-life-for-old-windows"
				target="_blank"
				rel="noreferrer"
				><Image
					src={thisOldHouseLogo}
					alt="This Old House"
					class="max-w-44"
				/></a
			>
		</li>
		<li>
			<a href="/static/pdfs/ARRG17_100-103.pdf" target="_blank"
				><Image class="max-w-44" src={atomicRanchLogo} alt="Atomic Ranch" /></a
			>
		</li>
		<li>
			<a
				href="https://www.nytimes.com/2014/09/21/fashion/the-paleo-lifestyle-the-way-way-way-back.html?_r=0"
				target="_blank"
				rel="noreferrer"
				><Image
					class="max-w-44"
					src={theNewYorkTimesLogo}
					alt="The New York Times"
				/></a
			>
		</li>
	</Grid>
	<p><a href="/about-indow/media/media-list">See More</a></p>
	<hr />
	<h2>Listen/Watch</h2>
	<Grid
		columns={4}
		rows={1}
		class="w-full list-none place-items-center justify-between"
	>
		<li class="flex">
			<a
				href="https://www.yellowbrickhome.com/indow-storm-windows/"
				target="_blank"
				rel="noreferrer"
				><Image
					class="max-w-44"
					src={yellowBrickHomeLogo}
					alt="Yellow Brick Home"
				/></a
			>
		</li>
		<li>
			<a
				href="https://www.youtube.com/watch?v=SdB7Oj1Ayv4"
				target="_blank"
				rel="noreferrer"
				><Image
					class="max-w-44"
					src={theCraftmansBlogLogo}
					alt="The Craftsman blog"
				/></a
			>
		</li>
		<li>
			<a
				href="https://www.youtube.com/watch?v=4Tizzpcfmm0"
				target="_blank"
				rel="noreferrer"><Image src={dayMomLogo} alt="DIY Mom" /></a
			>
		</li>
		<li>
			<a
				href="https://vintagerevivals.com/buh-bye-road-noise-made-historic-windows-better-indow/"
				target="_blank"
				rel="noreferrer"
				><Image
					class="max-w-44"
					src={vintageRevivalLogo}
					alt="Vinatge Revivals"
				/></a
			>
		</li>
	</Grid>
	<p><a href="/about-indow/media/media-list">See More</a></p>
	<hr />
	<h2>Awards</h2>
	<Grid
		columns={4}
		rows={1}
		class="w-full list-none place-items-center justify-between"
	>
		<li>
			<a
				href="https://www.oregonbusiness.com/100best/green/item/16928-100-best-green"
				rel="noreferrer"
				target="_blank"
				><Image
					class="max-w-44"
					src={bestGreenWorkplacesLogo}
					alt="Workplaces in Oregon"
				/></a
			>
		</li>
		<li>
			<a
				href="https://www.environmentalleader.com/2014/03/announcing-el-product-project-award-winners-2014/"
				target="_blank"
				rel="noreferrer"
				><Image
					class="max-w-44"
					src={environmentalLeaderLogo}
					alt="Environmental Leader"
				/></a
			>
		</li>
		<li>
			<a
				href="https://www.oen.org/2020/11/19/2020-oen-entrepreneurship-award-winners/"
				target="_blank"
				rel="noreferrer"
				><Image src={entrepreneursLogo} alt="Oregon Entrepeneurs Network" /></a
			>
		</li>
		<li>
			<a
				href="https://www.dwell.com/collection/highlights-from-greenbuild-2012-e9c04d15#9"
				target="_blank"
				rel="noreferrer"
				><Image class="max-w-44" src={dwellLogo} alt="Dwell" /></a
			>
		</li>
	</Grid>
	<p><a href="/about-indow/media/media-list">See More</a></p>
	<hr />
	<p><a href="/about-indow/media/media-list">View Full Media List</a></p>
	<p>
		We promise award-winning Indow window inserts will enhance your windows and
		make your space a more comfortable place to be. Don’t be shy. Get a free
		estimate today and let us help you figure out the right solution for your
		windows. (We’re super friendly.)
	</p>
</Section>

<GetAFreeEstimate />
<OurLocation />
<FeaturedArticles />
